import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import {
  useAddGuestToEventMutation,
  useEventGuestsQuery,
  useRemoveGuestFromEventMutation,
} from '@/enitites/event/api/queries'
import { useImage } from '@/shared/composables/image'
import BKInput from '@/components/AppShared/BKInput.vue'
import { useUsersInfiniteQuery } from '@/enitites/user/api/queries'
import useValidationRules from '@/shared/composables/validation'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { UserDB } from '@/enitites/user'
import { IEventGuestPayload } from '@/enitites/event/model/types'
import { mdiMinusCircleOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventGuestList',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};





const errorMessage = ref<string>()

const searchKey = ref('')

const { getAvatar } = useImage()
const rules = useValidationRules()

const { data: guests, isLoading: isLoadingGuests, error: errorGuests } = useEventGuestsQuery(props.eventData.id)
const { data: searchResults, isLoading: isLoadingSearchResults } = useUsersInfiniteQuery(
  // @ts-expect-error ignore
  computed(() => {
    return {
      pageSize: 100,
      keyword: searchKey.value,
      exclude: guests.value ? guests.value.map((guest) => guest.assignedTo?.userId) : [],
    }
  })
)
const { mutate: addGuestMutation, isPending: isAddingGuest, error: errorAddingGuest } = useAddGuestToEventMutation()
const {
  mutate: removeGuestMutation,
  isPending: isRemovingGuest,
  error: errorRemovingGuest,
} = useRemoveGuestFromEventMutation()

const searchUsers = computed(() => {
  return searchResults.value ? searchResults.value.pages.flatMap((page) => page) : []
})
const selectedGuest = ref<UserDB | string | null>(null)
const fullNameForEmail = ref('')
const label = ref('')
const selectedTierId = ref<number | null>(null)
const isFormValid = ref(false)

const updateUserSelectorKey = ref(0)
const handleSelectedUserChange = () => {
  updateUserSelectorKey.value += 1
}

const validate = (value: unknown) => {
  if (typeof value === 'string') {
    return rules.email(value)
  }
  if (value && typeof value === 'object' && ('id' in value || 'userId' in value)) {
    return true
  }
  return 'Please select a valid user or enter a valid email address.'
}

const handleAddGuest = async () => {
  if (!selectedGuest.value || !selectedTierId.value || isAddingGuest.value) return

  const guestData: IEventGuestPayload =
    typeof selectedGuest.value === 'string'
      ? {
          tierId: selectedTierId.value,
          label: label.value,
          email: selectedGuest.value,
          name: fullNameForEmail.value,
        }
      : {
          userId: selectedGuest.value.id,
          tierId: selectedTierId.value,
          label: label.value,
        }

  addGuestMutation(
    {
      eventId: props.eventData.id,
      data: guestData,
    },
    {
      onSuccess() {
        selectedGuest.value = null
        fullNameForEmail.value = ''
        label.value = ''
        selectedTierId.value = null
        isFormValid.value = false
      },
    }
  )
}

const handleRemoveGuest = async (guestId: number) => {
  if (isRemovingGuest.value) return

  removeGuestMutation({
    eventId: props.eventData.id,
    guestId,
  })
}

function handleNext() {
  emit('next')
}

function handleCancel() {
  emit('cancel')
}

const getAgeByBirthdate = (birthdate: string): number => {
  const today = new Date()
  const birthDate = new Date(birthdate)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }
  return age
}

return { __sfc: true,props, emit, errorMessage, searchKey, getAvatar, rules, guests, isLoadingGuests, errorGuests, searchResults, isLoadingSearchResults, addGuestMutation, isAddingGuest, errorAddingGuest, removeGuestMutation, isRemovingGuest, errorRemovingGuest, searchUsers, selectedGuest, fullNameForEmail, label, selectedTierId, isFormValid, updateUserSelectorKey, handleSelectedUserChange, validate, handleAddGuest, handleRemoveGuest, handleNext, handleCancel, getAgeByBirthdate, EventEditActionButtons, BKInput, AvatarPlaceholder, mdiMinusCircleOutline }
}

})